export enum MEDIA_TYPES {
	IMAGE = 1,
	AUDIO = 2,
	VIDEO = 3,
	AUDIO_VIDEO = 4,
	TEXT = 5,
	FILE = 6,
	SYSTEM = 7,
}
